<button class="btn btn-sm btn-outline-primary" (click)="openModal()" title="Xóa sản phẩm cho tài khoản">
  <i class="fas fa-broom"></i>
</button>


<div class="modal fade show" tabindex="-1" [ngStyle]="{display: show ? 'block' : 'none', background: 'rgba(0,0,0,0.5)'}" *ngIf="show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Xóa sản phẩm cho tài khoản: {{ merchant?.name }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label>View file</label>
            <input type="file" class="form-control" (change)="onFileChange($event)" />
          </div>
          <div class="form-group">
            <label>Số view</label>
            <input type="number" class="form-control" [(ngModel)]="minViewCount" name="minViewCount" min="1" />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="onSubmit()">Xóa</button>
      </div>
    </div>
  </div>
</div>
